import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { toRefs, watch } from 'vue';
import StarterKit from '@tiptap/starter-kit';
import CharacterCount from '@tiptap/extension-character-count';
import Link from '@tiptap/extension-link';
import { useEditor, EditorContent } from '@tiptap/vue-3';

import MenuBar from './MenuBar.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Editor',
  props: {
    error: { type: Boolean },
    value: { default: '' },
    maxlength: {},
    showCounter: { type: Boolean }
  },
  emits: ["blur", "update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const {
  value,
  maxlength,
} = toRefs(props);

const getNoTrailingBreakHtml = (editor: any) => {
  const html = editor.getHTML();
  return html.replace(/<p><br class="ProseMirror-trailingBreak"><\/p>|^<p><\/p>$/g, '');
};

const editorComp = useEditor({
  content: value.value,
  extensions: [
    StarterKit,
    Link,
    CharacterCount.configure({
      limit: maxlength.value,
    }),
  ],
  onBlur: ({ editor }) => {
    emits('blur', getNoTrailingBreakHtml(editor));
  },
  onUpdate: ({ editor }) => {
    emits('update', getNoTrailingBreakHtml(editor));
  },
});

watch(
  () => props.value,
  (newVal: string) => {
    const isSame = editorComp.value?.getHTML() === newVal;

    if (isSame) {
      return;
    }

    editorComp.value?.commands.setContent(newVal);
  }
);

return (_ctx: any,_cache: any) => {
  return (_unref(editorComp))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["editor", { 'error': _ctx.error }])
      }, [
        _createVNode(MenuBar, {
          class: "editor__header",
          editor: _unref(editorComp)
        }, null, 8, ["editor"]),
        _createVNode(_unref(EditorContent), {
          class: "editor__content",
          editor: _unref(editorComp),
          maxlength: _unref(maxlength)
        }, null, 8, ["editor", "maxlength"]),
        (_ctx.showCounter)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["editor__counter", {
        'editor__counter-max': _unref(editorComp).storage.characterCount.characters() === _unref(maxlength),
      }])
            }, _toDisplayString(_unref(editorComp).storage.characterCount.characters()) + " / " + _toDisplayString(_unref(maxlength)), 3))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})